/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Authorization Service
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";

import type { ErrorType } from "@/mutator/authApiInstance.ts";
import { authApiInstance } from "@/mutator/authApiInstance.ts";

import type {
  AuthServerAgentLoginRequest,
  AuthServerChangePasswordRequest,
  AuthServerChangeUsernameRequest,
  AuthServerMagicLoginRequest,
  AuthServerMagicLoginResponse,
  AuthServerSetPasswordRequest,
  AuthServerValidateUserTokenRequest,
  CancelSetupResponse,
  ChangeTwoFactorAuthenticationParams,
  ChangeTwoFactorAuthenticationSMSNumberParams,
  CompaxOAuth2AccessTokenModel,
  CreateMagicLoginParams,
  OAuth2AccessToken,
  OpenIdUserInfo,
  ResendParams,
  SendTwoFactorSmsCodeResponse,
  SetUpTwoFactorAuthenticationParams,
  SetUpTwoFactorAuthenticationReponse,
  TwoFactorAuthenticationBackupCodeConfirmation,
  TwoFactorAuthenticationResponse,
  ValidateParams,
  ValidateTwoFactorAuthenticationParams,
  ValidateTwoFactorAuthenticationResponse,
} from "./model";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") {
      continue;
    }
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }

  return result;
};

/**
 * @summary Agent login
 */
export const agentlogin = (
  authServerAgentLoginRequest: AuthServerAgentLoginRequest,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<CompaxOAuth2AccessTokenModel>(
    {
      url: `/user/agentlogin`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authServerAgentLoginRequest,
    },
    options,
  );
};

export const getAgentloginMutationKey = () => ["agentlogin"] as const;

export const getAgentloginMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof agentlogin>>,
    TError,
    AgentloginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof agentlogin>>,
  TError,
  AgentloginMutationVariables,
  TContext
> => {
  const mutationKey = getAgentloginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof agentlogin>>,
    AgentloginMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return agentlogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AgentloginMutationResult = NonNullable<
  Awaited<ReturnType<typeof agentlogin>>
>;
export type AgentloginMutationBody = AuthServerAgentLoginRequest;
export type AgentloginMutationError = ErrorType<unknown>;
export type AgentloginMutationVariables = { data: AuthServerAgentLoginRequest };

/**
 * @summary Agent login
 */
export const useAgentlogin = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof agentlogin>>,
      TError,
      AgentloginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof agentlogin>>,
  TError,
  AgentloginMutationVariables,
  TContext
> => {
  return useMutation(getAgentloginMutationOptions(options), queryClient);
};

/**
 * @summary Login via magic-link
 */
export const magicLoginConsume = (
  authServerMagicLoginRequest: AuthServerMagicLoginRequest,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<CompaxOAuth2AccessTokenModel>(
    {
      url: `/user/magic-link/consume`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authServerMagicLoginRequest,
    },
    options,
  );
};

export const getMagicLoginConsumeMutationKey = () =>
  ["magicLoginConsume"] as const;

export const getMagicLoginConsumeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof magicLoginConsume>>,
    TError,
    MagicLoginConsumeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof magicLoginConsume>>,
  TError,
  MagicLoginConsumeMutationVariables,
  TContext
> => {
  const mutationKey = getMagicLoginConsumeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof magicLoginConsume>>,
    MagicLoginConsumeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return magicLoginConsume(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MagicLoginConsumeMutationResult = NonNullable<
  Awaited<ReturnType<typeof magicLoginConsume>>
>;
export type MagicLoginConsumeMutationBody = AuthServerMagicLoginRequest;
export type MagicLoginConsumeMutationError = ErrorType<unknown>;
export type MagicLoginConsumeMutationVariables = {
  data: AuthServerMagicLoginRequest;
};

/**
 * @summary Login via magic-link
 */
export const useMagicLoginConsume = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof magicLoginConsume>>,
      TError,
      MagicLoginConsumeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof magicLoginConsume>>,
  TError,
  MagicLoginConsumeMutationVariables,
  TContext
> => {
  return useMutation(getMagicLoginConsumeMutationOptions(options), queryClient);
};

/**
 * @summary create magic-link
 */
export const createMagicLogin = (
  params: CreateMagicLoginParams,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<AuthServerMagicLoginResponse>(
    { url: `/user/magic-link/request`, method: "POST", params },
    options,
  );
};

export const getCreateMagicLoginMutationKey = () =>
  ["createMagicLogin"] as const;

export const getCreateMagicLoginMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMagicLogin>>,
    TError,
    CreateMagicLoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMagicLogin>>,
  TError,
  CreateMagicLoginMutationVariables,
  TContext
> => {
  const mutationKey = getCreateMagicLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMagicLogin>>,
    CreateMagicLoginMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return createMagicLogin(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMagicLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMagicLogin>>
>;

export type CreateMagicLoginMutationError = ErrorType<unknown>;
export type CreateMagicLoginMutationVariables = {
  params: CreateMagicLoginParams;
};

/**
 * @summary create magic-link
 */
export const useCreateMagicLogin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMagicLogin>>,
      TError,
      CreateMagicLoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createMagicLogin>>,
  TError,
  CreateMagicLoginMutationVariables,
  TContext
> => {
  return useMutation(getCreateMagicLoginMutationOptions(options), queryClient);
};

/**
 * @summary Validation of the 2FA Secure Zone Token
 */
export const validate = (
  params: ValidateParams,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<ValidateTwoFactorAuthenticationResponse>(
    { url: `/changeTwoFactor/validate`, method: "POST", params },
    options,
  );
};

export const getValidateMutationKey = () => ["validate"] as const;

export const getValidateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validate>>,
    TError,
    ValidateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validate>>,
  TError,
  ValidateMutationVariables,
  TContext
> => {
  const mutationKey = getValidateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validate>>,
    ValidateMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return validate(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof validate>>
>;

export type ValidateMutationError = ErrorType<unknown>;
export type ValidateMutationVariables = { params: ValidateParams };

/**
 * @summary Validation of the 2FA Secure Zone Token
 */
export const useValidate = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validate>>,
      TError,
      ValidateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validate>>,
  TError,
  ValidateMutationVariables,
  TContext
> => {
  return useMutation(getValidateMutationOptions(options), queryClient);
};

/**
 * @summary Authentication for changing 2FA settings
 */
export const authenticate = (
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<TwoFactorAuthenticationResponse>(
    { url: `/changeTwoFactor/authenticate2faSettings`, method: "POST" },
    options,
  );
};

export const getAuthenticateMutationKey = () => ["authenticate"] as const;

export const getAuthenticateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authenticate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authenticate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getAuthenticateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authenticate>>,
    void
  > = () => {
    return authenticate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthenticateMutationResult = NonNullable<
  Awaited<ReturnType<typeof authenticate>>
>;

export type AuthenticateMutationError = ErrorType<unknown>;

/**
 * @summary Authentication for changing 2FA settings
 */
export const useAuthenticate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authenticate>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authenticate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getAuthenticateMutationOptions(options), queryClient);
};

/**
 * @summary Change 2FA Method
 */
export const changeTwoFactorAuthentication = (
  params: ChangeTwoFactorAuthenticationParams,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<SetUpTwoFactorAuthenticationReponse>(
    { url: `/changeTwoFactor/change`, method: "POST", params },
    options,
  );
};

export const getChangeTwoFactorAuthenticationMutationKey = () =>
  ["changeTwoFactorAuthentication"] as const;

export const getChangeTwoFactorAuthenticationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeTwoFactorAuthentication>>,
    TError,
    ChangeTwoFactorAuthenticationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeTwoFactorAuthentication>>,
  TError,
  ChangeTwoFactorAuthenticationMutationVariables,
  TContext
> => {
  const mutationKey = getChangeTwoFactorAuthenticationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeTwoFactorAuthentication>>,
    ChangeTwoFactorAuthenticationMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return changeTwoFactorAuthentication(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeTwoFactorAuthenticationMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeTwoFactorAuthentication>>
>;

export type ChangeTwoFactorAuthenticationMutationError = ErrorType<unknown>;
export type ChangeTwoFactorAuthenticationMutationVariables = {
  params: ChangeTwoFactorAuthenticationParams;
};

/**
 * @summary Change 2FA Method
 */
export const useChangeTwoFactorAuthentication = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeTwoFactorAuthentication>>,
      TError,
      ChangeTwoFactorAuthenticationMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changeTwoFactorAuthentication>>,
  TError,
  ChangeTwoFactorAuthenticationMutationVariables,
  TContext
> => {
  return useMutation(
    getChangeTwoFactorAuthenticationMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Change phone number for 2FA SMS
 */
export const changeTwoFactorAuthenticationSMSNumber = (
  params: ChangeTwoFactorAuthenticationSMSNumberParams,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<SetUpTwoFactorAuthenticationReponse>(
    { url: `/changeTwoFactor/changeNumber`, method: "POST", params },
    options,
  );
};

export const getChangeTwoFactorAuthenticationSMSNumberMutationKey = () =>
  ["changeTwoFactorAuthenticationSMSNumber"] as const;

export const getChangeTwoFactorAuthenticationSMSNumberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeTwoFactorAuthenticationSMSNumber>>,
    TError,
    ChangeTwoFactorAuthenticationSMSNumberMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeTwoFactorAuthenticationSMSNumber>>,
  TError,
  ChangeTwoFactorAuthenticationSMSNumberMutationVariables,
  TContext
> => {
  const mutationKey = getChangeTwoFactorAuthenticationSMSNumberMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeTwoFactorAuthenticationSMSNumber>>,
    ChangeTwoFactorAuthenticationSMSNumberMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return changeTwoFactorAuthenticationSMSNumber(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeTwoFactorAuthenticationSMSNumberMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeTwoFactorAuthenticationSMSNumber>>
>;

export type ChangeTwoFactorAuthenticationSMSNumberMutationError =
  ErrorType<unknown>;
export type ChangeTwoFactorAuthenticationSMSNumberMutationVariables = {
  params: ChangeTwoFactorAuthenticationSMSNumberParams;
};

/**
 * @summary Change phone number for 2FA SMS
 */
export const useChangeTwoFactorAuthenticationSMSNumber = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeTwoFactorAuthenticationSMSNumber>>,
      TError,
      ChangeTwoFactorAuthenticationSMSNumberMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changeTwoFactorAuthenticationSMSNumber>>,
  TError,
  ChangeTwoFactorAuthenticationSMSNumberMutationVariables,
  TContext
> => {
  return useMutation(
    getChangeTwoFactorAuthenticationSMSNumberMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Display data for current 2FA method
 */
export const displayTwoFactorAuthenticationData = (
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<SetUpTwoFactorAuthenticationReponse>(
    { url: `/changeTwoFactor/displayTwoFactorData`, method: "POST" },
    options,
  );
};

export const getDisplayTwoFactorAuthenticationDataMutationKey = () =>
  ["displayTwoFactorAuthenticationData"] as const;

export const getDisplayTwoFactorAuthenticationDataMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof displayTwoFactorAuthenticationData>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof displayTwoFactorAuthenticationData>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getDisplayTwoFactorAuthenticationDataMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof displayTwoFactorAuthenticationData>>,
    void
  > = () => {
    return displayTwoFactorAuthenticationData(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisplayTwoFactorAuthenticationDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof displayTwoFactorAuthenticationData>>
>;

export type DisplayTwoFactorAuthenticationDataMutationError =
  ErrorType<unknown>;

/**
 * @summary Display data for current 2FA method
 */
export const useDisplayTwoFactorAuthenticationData = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof displayTwoFactorAuthenticationData>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof displayTwoFactorAuthenticationData>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getDisplayTwoFactorAuthenticationDataMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Set up 2FA - SMS/APP
 */
export const setUpTwoFactorAuthentication = (
  params: SetUpTwoFactorAuthenticationParams,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<SetUpTwoFactorAuthenticationReponse>(
    { url: `/twoFactor/setUp`, method: "POST", params },
    options,
  );
};

export const getSetUpTwoFactorAuthenticationMutationKey = () =>
  ["setUpTwoFactorAuthentication"] as const;

export const getSetUpTwoFactorAuthenticationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setUpTwoFactorAuthentication>>,
    TError,
    SetUpTwoFactorAuthenticationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setUpTwoFactorAuthentication>>,
  TError,
  SetUpTwoFactorAuthenticationMutationVariables,
  TContext
> => {
  const mutationKey = getSetUpTwoFactorAuthenticationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setUpTwoFactorAuthentication>>,
    SetUpTwoFactorAuthenticationMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return setUpTwoFactorAuthentication(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetUpTwoFactorAuthenticationMutationResult = NonNullable<
  Awaited<ReturnType<typeof setUpTwoFactorAuthentication>>
>;

export type SetUpTwoFactorAuthenticationMutationError = ErrorType<unknown>;
export type SetUpTwoFactorAuthenticationMutationVariables = {
  params: SetUpTwoFactorAuthenticationParams;
};

/**
 * @summary Set up 2FA - SMS/APP
 */
export const useSetUpTwoFactorAuthentication = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setUpTwoFactorAuthentication>>,
      TError,
      SetUpTwoFactorAuthenticationMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setUpTwoFactorAuthentication>>,
  TError,
  SetUpTwoFactorAuthenticationMutationVariables,
  TContext
> => {
  return useMutation(
    getSetUpTwoFactorAuthenticationMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Cancel 2FA activation process
 */
export const cancelSetup = (
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<CancelSetupResponse>(
    { url: `/twoFactor/cancelSetUp`, method: "POST" },
    options,
  );
};

export const getCancelSetupMutationKey = () => ["cancelSetup"] as const;

export const getCancelSetupMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelSetup>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelSetup>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCancelSetupMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelSetup>>,
    void
  > = () => {
    return cancelSetup(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelSetupMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelSetup>>
>;

export type CancelSetupMutationError = ErrorType<unknown>;

/**
 * @summary Cancel 2FA activation process
 */
export const useCancelSetup = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelSetup>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelSetup>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCancelSetupMutationOptions(options), queryClient);
};

/**
 * @summary Validate given code
 */
export const validateTwoFactorAuthentication = (
  params: ValidateTwoFactorAuthenticationParams,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<ValidateTwoFactorAuthenticationResponse>(
    { url: `/twoFactor/validate`, method: "POST", params },
    options,
  );
};

export const getValidateTwoFactorAuthenticationMutationKey = () =>
  ["validateTwoFactorAuthentication"] as const;

export const getValidateTwoFactorAuthenticationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateTwoFactorAuthentication>>,
    TError,
    ValidateTwoFactorAuthenticationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateTwoFactorAuthentication>>,
  TError,
  ValidateTwoFactorAuthenticationMutationVariables,
  TContext
> => {
  const mutationKey = getValidateTwoFactorAuthenticationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateTwoFactorAuthentication>>,
    ValidateTwoFactorAuthenticationMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return validateTwoFactorAuthentication(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateTwoFactorAuthenticationMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateTwoFactorAuthentication>>
>;

export type ValidateTwoFactorAuthenticationMutationError = ErrorType<unknown>;
export type ValidateTwoFactorAuthenticationMutationVariables = {
  params: ValidateTwoFactorAuthenticationParams;
};

/**
 * @summary Validate given code
 */
export const useValidateTwoFactorAuthentication = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateTwoFactorAuthentication>>,
      TError,
      ValidateTwoFactorAuthenticationMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validateTwoFactorAuthentication>>,
  TError,
  ValidateTwoFactorAuthenticationMutationVariables,
  TContext
> => {
  return useMutation(
    getValidateTwoFactorAuthenticationMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Confirm receipt of the backup codes
 */
export const confirmTwoFactorAuthenticationBackupCodes = (
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<TwoFactorAuthenticationBackupCodeConfirmation>(
    { url: `/twoFactor/confirmBackupCodes`, method: "POST" },
    options,
  );
};

export const getConfirmTwoFactorAuthenticationBackupCodesMutationKey = () =>
  ["confirmTwoFactorAuthenticationBackupCodes"] as const;

export const getConfirmTwoFactorAuthenticationBackupCodesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmTwoFactorAuthenticationBackupCodes>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmTwoFactorAuthenticationBackupCodes>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getConfirmTwoFactorAuthenticationBackupCodesMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmTwoFactorAuthenticationBackupCodes>>,
    void
  > = () => {
    return confirmTwoFactorAuthenticationBackupCodes(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmTwoFactorAuthenticationBackupCodesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof confirmTwoFactorAuthenticationBackupCodes>>
  >;

export type ConfirmTwoFactorAuthenticationBackupCodesMutationError =
  ErrorType<unknown>;

/**
 * @summary Confirm receipt of the backup codes
 */
export const useConfirmTwoFactorAuthenticationBackupCodes = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmTwoFactorAuthenticationBackupCodes>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof confirmTwoFactorAuthenticationBackupCodes>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getConfirmTwoFactorAuthenticationBackupCodesMutationOptions(options),
    queryClient,
  );
};

/**
 * @summary Resend twoFactor sms
 */
export const resend = (
  params: ResendParams,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<SendTwoFactorSmsCodeResponse>(
    { url: `/twoFactor/resendSms`, method: "POST", params },
    options,
  );
};

export const getResendMutationKey = () => ["resend"] as const;

export const getResendMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resend>>,
    TError,
    ResendMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resend>>,
  TError,
  ResendMutationVariables,
  TContext
> => {
  const mutationKey = getResendMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resend>>,
    ResendMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return resend(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendMutationResult = NonNullable<
  Awaited<ReturnType<typeof resend>>
>;

export type ResendMutationError = ErrorType<unknown>;
export type ResendMutationVariables = { params: ResendParams };

/**
 * @summary Resend twoFactor sms
 */
export const useResend = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resend>>,
      TError,
      ResendMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resend>>,
  TError,
  ResendMutationVariables,
  TContext
> => {
  return useMutation(getResendMutationOptions(options), queryClient);
};

/**
 * @summary Logout
 */
export const logout = (options?: SecondParameter<typeof authApiInstance>) => {
  return authApiInstance<void>(
    { url: `/user/logout`, method: "POST" },
    options,
  );
};

export const getLogoutMutationKey = () => ["logout"] as const;

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getLogoutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary Logout
 */
export const useLogout = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof logout>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options), queryClient);
};

/**
 * @summary Set password
 */
export const setPassword = (
  authServerSetPasswordRequest: AuthServerSetPasswordRequest,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<void>(
    {
      url: `/user/set-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authServerSetPasswordRequest,
    },
    options,
  );
};

export const getSetPasswordMutationKey = () => ["setPassword"] as const;

export const getSetPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setPassword>>,
    TError,
    SetPasswordMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setPassword>>,
  TError,
  SetPasswordMutationVariables,
  TContext
> => {
  const mutationKey = getSetPasswordMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setPassword>>,
    SetPasswordMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return setPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof setPassword>>
>;
export type SetPasswordMutationBody = AuthServerSetPasswordRequest;
export type SetPasswordMutationError = ErrorType<unknown>;
export type SetPasswordMutationVariables = {
  data: AuthServerSetPasswordRequest;
};

/**
 * @summary Set password
 */
export const useSetPassword = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setPassword>>,
      TError,
      SetPasswordMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setPassword>>,
  TError,
  SetPasswordMutationVariables,
  TContext
> => {
  return useMutation(getSetPasswordMutationOptions(options), queryClient);
};

/**
 * @summary Change password
 */
export const changePassword = (
  authServerChangePasswordRequest: AuthServerChangePasswordRequest,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<OAuth2AccessToken>(
    {
      url: `/user/change-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authServerChangePasswordRequest,
    },
    options,
  );
};

export const getChangePasswordMutationKey = () => ["changePassword"] as const;

export const getChangePasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    ChangePasswordMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  ChangePasswordMutationVariables,
  TContext
> => {
  const mutationKey = getChangePasswordMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePassword>>,
    ChangePasswordMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return changePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePassword>>
>;
export type ChangePasswordMutationBody = AuthServerChangePasswordRequest;
export type ChangePasswordMutationError = ErrorType<unknown>;
export type ChangePasswordMutationVariables = {
  data: AuthServerChangePasswordRequest;
};

/**
 * @summary Change password
 */
export const useChangePassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changePassword>>,
      TError,
      ChangePasswordMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  ChangePasswordMutationVariables,
  TContext
> => {
  return useMutation(getChangePasswordMutationOptions(options), queryClient);
};

/**
 * @summary validate user token
 */
export const validateUserToken = (
  authServerValidateUserTokenRequest: AuthServerValidateUserTokenRequest,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<void>(
    {
      url: `/user/user-token`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authServerValidateUserTokenRequest,
    },
    options,
  );
};

export const getValidateUserTokenMutationKey = () =>
  ["validateUserToken"] as const;

export const getValidateUserTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateUserToken>>,
    TError,
    ValidateUserTokenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateUserToken>>,
  TError,
  ValidateUserTokenMutationVariables,
  TContext
> => {
  const mutationKey = getValidateUserTokenMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateUserToken>>,
    ValidateUserTokenMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return validateUserToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateUserTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateUserToken>>
>;
export type ValidateUserTokenMutationBody = AuthServerValidateUserTokenRequest;
export type ValidateUserTokenMutationError = ErrorType<unknown>;
export type ValidateUserTokenMutationVariables = {
  data: AuthServerValidateUserTokenRequest;
};

/**
 * @summary validate user token
 */
export const useValidateUserToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateUserToken>>,
      TError,
      ValidateUserTokenMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validateUserToken>>,
  TError,
  ValidateUserTokenMutationVariables,
  TContext
> => {
  return useMutation(getValidateUserTokenMutationOptions(options), queryClient);
};

/**
 * @summary Check if user exists
 */
export const userExists = (
  username: string,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<void>(
    { url: `/user/${username}`, method: "HEAD" },
    options,
  );
};

export const getUserExistsMutationKey = () => ["userExists"] as const;

export const getUserExistsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userExists>>,
    TError,
    UserExistsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userExists>>,
  TError,
  UserExistsMutationVariables,
  TContext
> => {
  const mutationKey = getUserExistsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userExists>>,
    UserExistsMutationVariables
  > = (props) => {
    const { username } = props ?? {};

    return userExists(username, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserExistsMutationResult = NonNullable<
  Awaited<ReturnType<typeof userExists>>
>;

export type UserExistsMutationError = ErrorType<unknown>;
export type UserExistsMutationVariables = { username: string };

/**
 * @summary Check if user exists
 */
export const useUserExists = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userExists>>,
      TError,
      UserExistsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userExists>>,
  TError,
  UserExistsMutationVariables,
  TContext
> => {
  return useMutation(getUserExistsMutationOptions(options), queryClient);
};

/**
 * @summary Change username for Login
 */
export const changeUsername = (
  authServerChangeUsernameRequest: AuthServerChangeUsernameRequest,
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<OAuth2AccessToken>(
    {
      url: `/user/change-username`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authServerChangeUsernameRequest,
    },
    options,
  );
};

export const getChangeUsernameMutationKey = () => ["changeUsername"] as const;

export const getChangeUsernameMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeUsername>>,
    TError,
    ChangeUsernameMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeUsername>>,
  TError,
  ChangeUsernameMutationVariables,
  TContext
> => {
  const mutationKey = getChangeUsernameMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeUsername>>,
    ChangeUsernameMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return changeUsername(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeUsernameMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeUsername>>
>;
export type ChangeUsernameMutationBody = AuthServerChangeUsernameRequest;
export type ChangeUsernameMutationError = ErrorType<unknown>;
export type ChangeUsernameMutationVariables = {
  data: AuthServerChangeUsernameRequest;
};

/**
 * @summary Change username for Login
 */
export const useChangeUsername = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeUsername>>,
      TError,
      ChangeUsernameMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changeUsername>>,
  TError,
  ChangeUsernameMutationVariables,
  TContext
> => {
  return useMutation(getChangeUsernameMutationOptions(options), queryClient);
};

/**
 * @summary Get userinfo
 */
export const getOpenIdUserInfo = (
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<OpenIdUserInfo>(
    { url: `/user`, method: "GET" },
    options,
  );
};

export const getGetOpenIdUserInfoQueryKey = () => {
  return [`/user`] as const;
};

export const getGetOpenIdUserInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getOpenIdUserInfo>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getOpenIdUserInfo>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof authApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOpenIdUserInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOpenIdUserInfo>>
  > = () => getOpenIdUserInfo(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOpenIdUserInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOpenIdUserInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOpenIdUserInfo>>
>;
export type GetOpenIdUserInfoQueryError = ErrorType<unknown>;

export function useGetOpenIdUserInfo<
  TData = Awaited<ReturnType<typeof getOpenIdUserInfo>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOpenIdUserInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpenIdUserInfo>>,
          TError,
          Awaited<ReturnType<typeof getOpenIdUserInfo>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOpenIdUserInfo<
  TData = Awaited<ReturnType<typeof getOpenIdUserInfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOpenIdUserInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpenIdUserInfo>>,
          TError,
          Awaited<ReturnType<typeof getOpenIdUserInfo>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOpenIdUserInfo<
  TData = Awaited<ReturnType<typeof getOpenIdUserInfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOpenIdUserInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get userinfo
 */

export function useGetOpenIdUserInfo<
  TData = Awaited<ReturnType<typeof getOpenIdUserInfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOpenIdUserInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOpenIdUserInfoQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get userinfo
 */
export const getOpenIdUserInfo1 = (
  options?: SecondParameter<typeof authApiInstance>,
) => {
  return authApiInstance<OpenIdUserInfo>(
    { url: `/user`, method: "POST" },
    options,
  );
};

export const getGetOpenIdUserInfo1MutationKey = () =>
  ["getOpenIdUserInfo1"] as const;

export const getGetOpenIdUserInfo1MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getOpenIdUserInfo1>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof authApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getOpenIdUserInfo1>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getGetOpenIdUserInfo1MutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getOpenIdUserInfo1>>,
    void
  > = () => {
    return getOpenIdUserInfo1(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetOpenIdUserInfo1MutationResult = NonNullable<
  Awaited<ReturnType<typeof getOpenIdUserInfo1>>
>;

export type GetOpenIdUserInfo1MutationError = ErrorType<unknown>;

/**
 * @summary Get userinfo
 */
export const useGetOpenIdUserInfo1 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getOpenIdUserInfo1>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof authApiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getOpenIdUserInfo1>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getGetOpenIdUserInfo1MutationOptions(options),
    queryClient,
  );
};
